import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
/* Importaciones  Angular Material */
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { MatDialogModule} from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatDividerModule} from '@angular/material/divider';
import { MatInputModule} from '@angular/material/input';
import { MatPaginatorModule} from '@angular/material/paginator';
import { MatTableModule} from '@angular/material/table';
import { MatCheckboxModule} from '@angular/material/checkbox';
import { MatRadioModule} from '@angular/material/radio';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatButtonModule} from '@angular/material/button';
import { MatSelectModule} from '@angular/material/select';
import { MatChipsModule} from '@angular/material/chips';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { RolesDirective } from './../services/directives/roles/roles.directive';
import { RolesNegDirective } from './../services/directives/roles-neg/roles-neg.directive';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { FiltersComponent } from '../components/filters/filters.component';
import { GraficaLinealComponent } from '../components/grafica-lineal/grafica-lineal.component';
import {MatTabsModule} from '@angular/material/tabs';
import { GraficasComponent } from '../components/graficas/graficas.component';
import { TarjetasComponent } from '../components/tarjetas/tarjetas.component';
import { NgxGanttModule } from '@worktile/gantt';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MenuPerspectivasComponent } from '../elements/riesgo-credito/menu-perspectivas/menu-perspectivas.component';
import { GraficadorComponent } from '../components/graficador/graficador.component';
import { CapitalizePipe } from '../components/pipes/capitalize.pipe';
import { SelectTitleComponent } from '../components/select-title/select-title.component';
import { CustomToolTipDirective } from '../services/directives/tooltip/custom-tool-tip.directive';
import { ModalComponent } from '../components/modal/modal.component';
import { SkeletonTableComponent } from '../components/skeleton-table/skeleton-table.component';
import { SkeletonCardComponent } from '../components/skeleton-cards/skeleton-card.component';
import { SkeletonGraficaComponent } from '../components/skeleton-grafica/skeleton-grafica.component';
import { EsqueletoTablerosComponent } from '../components/esqueleto-tableros/esqueleto-tableros.component'; 
import { FormaterNumberPipe } from '../services/pipes/formater-number.pipe';
import { ScrollContainerComponent } from '../components/scroll-container/scroll-container.component';
import { FilterOverlayComponent } from '../components/filters/components/filter-overlay/filter-overlay.component';
import { FilterControlComponent } from '../components/filters/components/filter-control/filter-control.component';
import { CdkOverlayOrigin, CdkConnectedOverlay } from "@angular/cdk/overlay";
import { OptionsSelectComponent } from '../components/filters/components/options-select/options-select.component';
import { OverFlowTooltipDirective } from '../services/directives/overflow/overflow.directive';
import { TreeMenuComponent } from '../components/filters/components/tree-menu/tree-menu.component';
import { BusquedaOptionComponent } from '../components/filters/components/busqueda-option/busqueda-option.component';
import { ContenedorElementosComponent } from '../components/contenedor-elementos/contenedor-elementos.component';
import { ChipsDirective } from "../components/contenedor-elementos/directive/chips-fit.directive";
import { ButtonComponent } from '../components/button/button.component';
import { GanttComponent } from '../components/gantt/gantt.component';

@NgModule({
  declarations: [
    RolesDirective,
    RolesNegDirective,
    CustomToolTipDirective,
    OverFlowTooltipDirective,
    FiltersComponent,
    GraficaLinealComponent,
    GraficasComponent,
    TarjetasComponent,
    MenuPerspectivasComponent,
    GraficadorComponent,
    CapitalizePipe,
    SelectTitleComponent,
    ModalComponent,
    SkeletonTableComponent,
    SkeletonGraficaComponent,
    SkeletonCardComponent,
    EsqueletoTablerosComponent,
    ScrollContainerComponent,
    FilterControlComponent,
    FilterOverlayComponent,
    OptionsSelectComponent,
    TreeMenuComponent,
    BusquedaOptionComponent,
    ContenedorElementosComponent,
    ButtonComponent,
    GanttComponent,
    //Pipes
    FormaterNumberPipe,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    MatSnackBarModule,
    MatDividerModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatSlideToggleModule,
    MatListModule,
    MatSliderModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatToolbarModule,
    ReactiveFormsModule,
    TranslateModule,
    CurrencyMaskModule,
    MatTreeModule,
    NgxSkeletonLoaderModule,
    // Graficas
    NgApexchartsModule,
    NgxChartsModule,
    MatTabsModule,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    ChipsDirective
],
  exports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatSidenavModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    MatSnackBarModule,
    MatDividerModule,
    MatInputModule,
    MatPaginatorModule,
    MatTableModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatSlideToggleModule,
    MatListModule,
    MatSliderModule,
    MatTooltipModule,
    MatButtonToggleModule,
    MatGridListModule,
    MatToolbarModule,
    ReactiveFormsModule,
    TranslateModule,
    CurrencyMaskModule,
    MatTreeModule,
    NgxSkeletonLoaderModule,
    /* Pipes */
    FormaterNumberPipe,
    /* Directivas */
    RolesDirective,
    RolesNegDirective,
    CustomToolTipDirective,
    OverFlowTooltipDirective,
    // Graficas
    NgApexchartsModule,
    NgxChartsModule,
    GraficaLinealComponent,
    GraficasComponent,
    TarjetasComponent,
    SelectTitleComponent,
    // componentes
    FiltersComponent,
    MatTabsModule,
    NgxGanttModule,
    MenuPerspectivasComponent,
    GraficadorComponent,
    CapitalizePipe,
    ModalComponent,
    SkeletonTableComponent,
    SkeletonGraficaComponent,
    SkeletonCardComponent,
    EsqueletoTablerosComponent,
    ScrollContainerComponent,
    FilterControlComponent,
    FilterOverlayComponent,
    OptionsSelectComponent,
    TreeMenuComponent,
    BusquedaOptionComponent,
    ContenedorElementosComponent,
    ButtonComponent,
    GanttComponent,
  ],
  providers: [
    CookieService
  ]
})
export class SharedModule { }
